// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%238e9aaf%27 d=%27M6 8L1 3h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,400;14..32,500;14..32,600;14..32,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern, compact, unique design - Same theme */

.discount-form {
  font-family: 'Inter', system-ui, sans-serif;
  background: rgba(18, 25, 45, 0.95);
  backdrop-filter: blur(2px);
  border-radius: 32px;
  padding: 28px 32px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.4);
  max-width: 1100px;
  margin: 0 auto;
  transition: all 0.2s;
}

/* ===== HEADER ===== */
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.form-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.form-header-icon {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #fbbf24, #f59e0b);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0a0f1a;
}

.form-header h3 {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(135deg, #fff, #a5f3c3);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin: 0 0 2px 0;
}

.form-header p {
  color: #8e9aaf;
  font-size: 13px;
  margin: 0;
}

.form-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.form-badge-create {
  background: rgba(34, 197, 94, 0.2);
  color: #4ade80;
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.form-badge-update {
  background: rgba(251, 191, 36, 0.2);
  color: #fbbf24;
  border: 1px solid rgba(251, 191, 36, 0.3);
}

/* ===== GRID ===== */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 24px;
}

.form-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ===== CARDS ===== */
.form-card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 18px 20px 20px;
  transition: all 0.2s;
}

.form-card:hover {
  border-color: rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
}

.form-card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #cdd9ff;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.form-card-title svg {
  color: #fbbf24;
}

/* ===== FIELDS ===== */
.field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 12px;
}

.field:last-child {
  margin-bottom: 0;
}

.field label {
  font-size: 12px;
  font-weight: 600;
  color: #cdd9ff;
  letter-spacing: 0.3px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.field label svg {
  color: #8e9aaf;
}

.required {
  color: #f87171;
  font-weight: 700;
}

.field input,
.field select,
.field textarea {
  background: #0f1422;
  border: 1px solid #2a3448;
  border-radius: 12px;
  padding: 10px 14px;
  font-size: 14px;
  color: #f0f3fa;
  transition: all 0.2s;
  font-family: inherit;
  width: 100%;
  box-sizing: border-box;
}

.field input:focus,
.field select:focus,
.field textarea:focus {
  outline: none;
  border-color: #fbbf24;
  box-shadow: 0 0 0 3px rgba(251, 191, 36, 0.12);
}

.field input::placeholder,
.field textarea::placeholder {
  color: #57647a;
}

.field textarea {
  resize: vertical;
  min-height: 60px;
}

.field select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 40px;
  cursor: pointer;
}

/* ===== DATE ROW ===== */
.date-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.date-row .field {
  margin-bottom: 0;
}

/* ===== TYPE TOGGLE ===== */
.type-group {
  display: flex;
  gap: 10px;
}

.type-option {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #0f1422;
  border: 1px solid #2a3448;
  border-radius: 40px;
  padding: 9px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #b9c3db;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}

.type-option:hover {
  border-color: #4a5a7a;
}

.type-option.active {
  background: linear-gradient(145deg, #fbbf24, #f59e0b);
  border-color: #fbbf24;
  color: #0a0f1a;
  box-shadow: 0 2px 8px rgba(251, 191, 36, 0.3);
}

.type-option svg {
  flex-shrink: 0;
}

/* ===== MULTI-SELECT ===== */
.multi-select {
  position: relative;
  width: 100%;
  font-size: 14px;
}

.multi-select__input-container {
  background: #0f1422;
  border: 1px solid #2a3448;
  border-radius: 12px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  min-height: 44px;
  transition: all 0.2s;
}

.multi-select__input-container:hover {
  border-color: #4a5a7a;
}

.multi-select__search-wrapper {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 8px;
}

.multi-select__search-icon {
  color: #6c7a99;
  flex-shrink: 0;
}

.multi-select__search {
  background: transparent;
  border: none;
  outline: none;
  color: white;
  font-size: 13px;
  padding: 10px 0;
  width: 100%;
}

.multi-select__search::placeholder {
  color: #6c7a99;
}

.multi-select__right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.multi-select__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 7px;
  background: #fbbf24;
  color: #0a0f1a;
  font-size: 11px;
  font-weight: 700;
  border-radius: 50px;
}

.multi-select__arrow {
  color: #8e9aaf;
  transition: transform 0.25s ease;
}

.multi-select__arrow.open {
  transform: rotate(180deg);
}

/* ===== DROPDOWN ===== */
.multi-select__dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background: #111827;
  border: 1px solid #2a3448;
  border-radius: 16px;
  max-height: 260px;
  overflow: hidden;
  z-index: 100;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.5);
  animation: dropdownFade 0.2s ease;
}

@keyframes dropdownFade {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.multi-select__dropdown-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #1a2332;
  border-bottom: 1px solid #2a3448;
}

.multi-select__option.select-all-row {
  margin: 0;
  padding: 6px 0;
}

.select-all-text {
  font-weight: 700;
  color: #fbbf24;
}

.multi-select__clear {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
  color: #f87171;
  background: rgba(248, 113, 113, 0.1);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.multi-select__clear:hover {
  background: rgba(248, 113, 113, 0.2);
}

.multi-select__divider {
  height: 1px;
  background: #2a3448;
}

.multi-select__options-list {
  max-height: 180px;
  overflow-y: auto;
  padding: 6px 0;
}

.multi-select__options-list::-webkit-scrollbar {
  width: 4px;
}

.multi-select__options-list::-webkit-scrollbar-track {
  background: #1a2332;
}

.multi-select__options-list::-webkit-scrollbar-thumb {
  background: #4a5a7a;
  border-radius: 10px;
}

.multi-select__option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s;
  color: #e2e8f0;
  font-size: 13px;
  margin: 0 6px;
}

.multi-select__option:hover {
  background: rgba(251, 191, 36, 0.08);
}

.multi-select__option input {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #fbbf24;
  flex-shrink: 0;
}

.multi-select__option-label {
  flex: 1 1;
}

.multi-select__option-type {
  font-size: 11px;
  color: #8e9aaf;
  margin-left: 4px;
}

.multi-select__check {
  color: #fbbf24;
  flex-shrink: 0;
}

.multi-select__loading,
.multi-select__empty {
  padding: 20px;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
}

.multi-select__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

/* ===== SELECTED PREVIEW ===== */
.multi-select__selected-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 4px 2px;
}

.multi-select__preview-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 500;
  color: #e2e8f0;
  background: rgba(251, 191, 36, 0.15);
  border-radius: 50px;
  border: 1px solid rgba(251, 191, 36, 0.2);
}

.multi-select__preview-more {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 500;
  color: #8e9aaf;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 50px;
}

/* ===== BUTTONS ===== */
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(105deg, #22c55e, #16a34a);
  border: none;
  padding: 10px 28px;
  border-radius: 40px;
  font-weight: 700;
  font-size: 14px;
  color: white;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 6px rgba(34, 197, 94, 0.3);
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(34, 197, 94, 0.4);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: 1px solid #3a4762;
  padding: 10px 28px;
  border-radius: 40px;
  font-weight: 600;
  font-size: 14px;
  color: #b9c6e6;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: #fbbf24;
  color: #fbbf24;
}

.spinner {
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* ===== RESPONSIVE ===== */
@media (max-width: 900px) {
  .discount-form {
    padding: 20px;
  }
  .form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 600px) {
  .discount-form {
    padding: 16px;
    border-radius: 20px;
  }
  .form-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .form-header h3 {
    font-size: 17px;
  }
  .date-row {
    grid-template-columns: 1fr;
  }
  .type-group {
    flex-direction: column;
  }
  .form-actions {
    flex-direction: column-reverse;
  }
  .btn-primary,
  .btn-secondary {
    width: 100%;
    justify-content: center;
  }
  .form-card {
    padding: 14px 16px;
  }
}

input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(1);
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Discount/components/DiscountForm.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAGhD;EACE,2CAA2C;EAC3C,kCAAkC;EAClC,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,gDAAgD;EAChD,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kDAAkD;EAClD,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yDAA0L;EAC1L,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,8BAA8B;EAChC;EACA;;IAEE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":["/* Modern, compact, unique design - Same theme */\n@import url('https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,400;14..32,500;14..32,600;14..32,700&display=swap');\n\n.discount-form {\n  font-family: 'Inter', system-ui, sans-serif;\n  background: rgba(18, 25, 45, 0.95);\n  backdrop-filter: blur(2px);\n  border-radius: 32px;\n  padding: 28px 32px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.4);\n  max-width: 1100px;\n  margin: 0 auto;\n  transition: all 0.2s;\n}\n\n/* ===== HEADER ===== */\n.form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.form-header-left {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.form-header-icon {\n  width: 44px;\n  height: 44px;\n  background: linear-gradient(135deg, #fbbf24, #f59e0b);\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #0a0f1a;\n}\n\n.form-header h3 {\n  font-size: 20px;\n  font-weight: 700;\n  background: linear-gradient(135deg, #fff, #a5f3c3);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  margin: 0 0 2px 0;\n}\n\n.form-header p {\n  color: #8e9aaf;\n  font-size: 13px;\n  margin: 0;\n}\n\n.form-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 16px;\n  border-radius: 50px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.form-badge-create {\n  background: rgba(34, 197, 94, 0.2);\n  color: #4ade80;\n  border: 1px solid rgba(34, 197, 94, 0.3);\n}\n\n.form-badge-update {\n  background: rgba(251, 191, 36, 0.2);\n  color: #fbbf24;\n  border: 1px solid rgba(251, 191, 36, 0.3);\n}\n\n/* ===== GRID ===== */\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.form-col {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ===== CARDS ===== */\n.form-card {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 20px;\n  padding: 18px 20px 20px;\n  transition: all 0.2s;\n}\n\n.form-card:hover {\n  border-color: rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.form-card-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #cdd9ff;\n  margin-bottom: 14px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.form-card-title svg {\n  color: #fbbf24;\n}\n\n/* ===== FIELDS ===== */\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-bottom: 12px;\n}\n\n.field:last-child {\n  margin-bottom: 0;\n}\n\n.field label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #cdd9ff;\n  letter-spacing: 0.3px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.field label svg {\n  color: #8e9aaf;\n}\n\n.required {\n  color: #f87171;\n  font-weight: 700;\n}\n\n.field input,\n.field select,\n.field textarea {\n  background: #0f1422;\n  border: 1px solid #2a3448;\n  border-radius: 12px;\n  padding: 10px 14px;\n  font-size: 14px;\n  color: #f0f3fa;\n  transition: all 0.2s;\n  font-family: inherit;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.field input:focus,\n.field select:focus,\n.field textarea:focus {\n  outline: none;\n  border-color: #fbbf24;\n  box-shadow: 0 0 0 3px rgba(251, 191, 36, 0.12);\n}\n\n.field input::placeholder,\n.field textarea::placeholder {\n  color: #57647a;\n}\n\n.field textarea {\n  resize: vertical;\n  min-height: 60px;\n}\n\n.field select {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%238e9aaf' d='M6 8L1 3h10z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 14px center;\n  padding-right: 40px;\n  cursor: pointer;\n}\n\n/* ===== DATE ROW ===== */\n.date-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.date-row .field {\n  margin-bottom: 0;\n}\n\n/* ===== TYPE TOGGLE ===== */\n.type-group {\n  display: flex;\n  gap: 10px;\n}\n\n.type-option {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: #0f1422;\n  border: 1px solid #2a3448;\n  border-radius: 40px;\n  padding: 9px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #b9c3db;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: center;\n}\n\n.type-option:hover {\n  border-color: #4a5a7a;\n}\n\n.type-option.active {\n  background: linear-gradient(145deg, #fbbf24, #f59e0b);\n  border-color: #fbbf24;\n  color: #0a0f1a;\n  box-shadow: 0 2px 8px rgba(251, 191, 36, 0.3);\n}\n\n.type-option svg {\n  flex-shrink: 0;\n}\n\n/* ===== MULTI-SELECT ===== */\n.multi-select {\n  position: relative;\n  width: 100%;\n  font-size: 14px;\n}\n\n.multi-select__input-container {\n  background: #0f1422;\n  border: 1px solid #2a3448;\n  border-radius: 12px;\n  padding: 0 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  min-height: 44px;\n  transition: all 0.2s;\n}\n\n.multi-select__input-container:hover {\n  border-color: #4a5a7a;\n}\n\n.multi-select__search-wrapper {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.multi-select__search-icon {\n  color: #6c7a99;\n  flex-shrink: 0;\n}\n\n.multi-select__search {\n  background: transparent;\n  border: none;\n  outline: none;\n  color: white;\n  font-size: 13px;\n  padding: 10px 0;\n  width: 100%;\n}\n\n.multi-select__search::placeholder {\n  color: #6c7a99;\n}\n\n.multi-select__right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.multi-select__count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 7px;\n  background: #fbbf24;\n  color: #0a0f1a;\n  font-size: 11px;\n  font-weight: 700;\n  border-radius: 50px;\n}\n\n.multi-select__arrow {\n  color: #8e9aaf;\n  transition: transform 0.25s ease;\n}\n\n.multi-select__arrow.open {\n  transform: rotate(180deg);\n}\n\n/* ===== DROPDOWN ===== */\n.multi-select__dropdown {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  background: #111827;\n  border: 1px solid #2a3448;\n  border-radius: 16px;\n  max-height: 260px;\n  overflow: hidden;\n  z-index: 100;\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.5);\n  animation: dropdownFade 0.2s ease;\n}\n\n@keyframes dropdownFade {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.multi-select__dropdown-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background: #1a2332;\n  border-bottom: 1px solid #2a3448;\n}\n\n.multi-select__option.select-all-row {\n  margin: 0;\n  padding: 6px 0;\n}\n\n.select-all-text {\n  font-weight: 700;\n  color: #fbbf24;\n}\n\n.multi-select__clear {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #f87171;\n  background: rgba(248, 113, 113, 0.1);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.multi-select__clear:hover {\n  background: rgba(248, 113, 113, 0.2);\n}\n\n.multi-select__divider {\n  height: 1px;\n  background: #2a3448;\n}\n\n.multi-select__options-list {\n  max-height: 180px;\n  overflow-y: auto;\n  padding: 6px 0;\n}\n\n.multi-select__options-list::-webkit-scrollbar {\n  width: 4px;\n}\n\n.multi-select__options-list::-webkit-scrollbar-track {\n  background: #1a2332;\n}\n\n.multi-select__options-list::-webkit-scrollbar-thumb {\n  background: #4a5a7a;\n  border-radius: 10px;\n}\n\n.multi-select__option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.15s;\n  color: #e2e8f0;\n  font-size: 13px;\n  margin: 0 6px;\n}\n\n.multi-select__option:hover {\n  background: rgba(251, 191, 36, 0.08);\n}\n\n.multi-select__option input {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: #fbbf24;\n  flex-shrink: 0;\n}\n\n.multi-select__option-label {\n  flex: 1;\n}\n\n.multi-select__option-type {\n  font-size: 11px;\n  color: #8e9aaf;\n  margin-left: 4px;\n}\n\n.multi-select__check {\n  color: #fbbf24;\n  flex-shrink: 0;\n}\n\n.multi-select__loading,\n.multi-select__empty {\n  padding: 20px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n.multi-select__loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n/* ===== SELECTED PREVIEW ===== */\n.multi-select__selected-preview {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 8px 4px 2px;\n}\n\n.multi-select__preview-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #e2e8f0;\n  background: rgba(251, 191, 36, 0.15);\n  border-radius: 50px;\n  border: 1px solid rgba(251, 191, 36, 0.2);\n}\n\n.multi-select__preview-more {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #8e9aaf;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 50px;\n}\n\n/* ===== BUTTONS ===== */\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.btn-primary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(105deg, #22c55e, #16a34a);\n  border: none;\n  padding: 10px 28px;\n  border-radius: 40px;\n  font-weight: 700;\n  font-size: 14px;\n  color: white;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 2px 6px rgba(34, 197, 94, 0.3);\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(34, 197, 94, 0.4);\n}\n\n.btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: transparent;\n  border: 1px solid #3a4762;\n  padding: 10px 28px;\n  border-radius: 40px;\n  font-weight: 600;\n  font-size: 14px;\n  color: #b9c6e6;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: #fbbf24;\n  color: #fbbf24;\n}\n\n.spinner {\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ===== RESPONSIVE ===== */\n@media (max-width: 900px) {\n  .discount-form {\n    padding: 20px;\n  }\n  .form-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n}\n\n@media (max-width: 600px) {\n  .discount-form {\n    padding: 16px;\n    border-radius: 20px;\n  }\n  .form-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n  .form-header h3 {\n    font-size: 17px;\n  }\n  .date-row {\n    grid-template-columns: 1fr;\n  }\n  .type-group {\n    flex-direction: column;\n  }\n  .form-actions {\n    flex-direction: column-reverse;\n  }\n  .btn-primary,\n  .btn-secondary {\n    width: 100%;\n    justify-content: center;\n  }\n  .form-card {\n    padding: 14px 16px;\n  }\n}\n\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n  filter: invert(1);\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
